module.exports = __webpack_public_path__ + "img/hr-cliff-entrance.28f87099.png";